import styled from 'styled-components';
import tw from 'twin.macro';
import resolveConfig from 'tailwindcss/resolveConfig';

import tailwindConfig from '../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

export const OverlayStyled = styled.div`
  ${tw`fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50 p-5`}
`;

export const ModalStyled = styled.div`
  ${tw`shadow-xl max-h-screen overflow-y-auto rounded-md py-12`}
  max-width: 900px;
  background-color: #1a1a1a;
  padding-left: 2rem;
  padding-right: 2rem;

  @media (min-width: ${fullConfig.theme.screens.sm}) {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  @media (min-width: ${fullConfig.theme.screens.lg}) {
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }
`;

export const TitleStyled = styled.h2`
  ${tw`text-2xl md:text-xl md:text-xl font-bold text-white text-center m-0 pb-8`}
`;

export const ContentStyled = styled.div`
  ${tw`text-sm md:text-base text-white leading-relaxed`}

  ul {
    ${tw`list-disc pl-5 space-y-5 md:space-y-3`}
  }
  li {
    ${tw`text-white font-medium leading-5 md:leading-6`}
  }
  strong {
    ${tw`font-medium leading-5 md:leading-6`}
  }
`;

export const LinkStyled = styled.a`
  ${tw`text-blue-500 underline hover:text-primary-500 hover:no-underline break-words`}
`;

export const ActionsStyled = styled.div`
  ${tw`flex flex-col md:flex-row gap-5 md:gap-4 pt-14 md:pt-8 rounded-b-xl`}
  justify-content: center;
`;

export const ButtonStyled = styled.button<{ $variant: 'agree' | 'disagree' }>`
  ${tw`text-white px-4 pt-2 pb-2 text-center`}
  ${tw`transition transition-all ease-in-out duration-200 rounded-md hover:text-primary-500 border-blue-600`};
  ${tw`w-full lg:w-auto border lg:border-none mb-0`};
  min-width: 215px;

  @media (min-width: ${fullConfig.theme.screens.lg}) {
  }

  &.agree-btn {
    ${tw`bg-primary-500 border border-primary-500 text-black hover:bg-primary-500 hover:text-black`}
  }

  &.disagree-btn {
    ${tw`border border-solid text-primary-500 border-primary-500 hover:bg-primary-500 hover:text-black`}
  }
`;
